var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3637 13.0908H4.90911V1.6363H16.3637V13.0908ZM16.3637 -6.10352e-05H4.90911C4.47512 -6.10352e-05 4.0589 0.172341 3.75202 0.479219C3.44514 0.786097 3.27274 1.20231 3.27274 1.6363V13.0908C3.27274 13.5248 3.44514 13.9411 3.75202 14.2479C4.0589 14.5548 4.47512 14.7272 4.90911 14.7272H16.3637C16.7976 14.7272 17.2139 14.5548 17.5207 14.2479C17.8276 13.9411 18 13.5248 18 13.0908V1.6363C18 1.20231 17.8276 0.786097 17.5207 0.479219C17.2139 0.172341 16.7976 -6.10352e-05 16.3637 -6.10352e-05ZM1.63638 3.27267H1.52588e-05V16.3636C1.52588e-05 16.7976 0.172417 17.2138 0.479295 17.5207C0.786173 17.8275 1.20239 17.9999 1.63638 17.9999H14.7273V16.3636H1.63638V3.27267ZM12.24 7.60085L9.99002 10.4972L8.38638 8.5663L6.13638 11.4545H15.1364L12.24 7.60085Z",
    fill: "#8B82A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPic);
export default __webpack_public_path__ + "static/media/pic.3a2bf134f3e8da3d74f864378916e03c.svg";
export { ForwardRef as ReactComponent };